<script setup lang="ts">
/*
  The small badge a list draws for a project or a dataspace the license has taken something from, so
  nobody opens a space to learn it: "Read-only" for a locked project, "Designer closed" for a
  project whose Designer is closed, "Locked" for a dataspace closed to the Operator. The reason is
  the badge's title — one line, on hover.

  Nothing is drawn for a space nothing is taken from. One badge for the Designer's cards and the
  Operator's table, like `SpaceLocationBadge`.
*/
import { computed } from "vue";
import { mdiLockOutline, mdiPencilOffOutline } from "@mdi/js";
import { HabBadge } from "@livereader/habitus-vue";
import type { SpaceKind, SpaceRestriction } from "@/api";
import { sayWords } from "@/shared/utils/spaceErrors";
import { restrictionBadge } from "@/shared/utils/spaceRestriction";

const props = defineProps<{
	kind: SpaceKind;
	restriction: SpaceRestriction | null | undefined;
}>();

const badge = computed(() => restrictionBadge(props.kind, props.restriction));
</script>

<template>
	<HabBadge
		v-if="badge"
		tone="warning"
		:icon="badge.part === 'designer' ? mdiPencilOffOutline : mdiLockOutline"
		:title="sayWords(badge.hint)"
	>
		{{ sayWords(badge.label) }}
	</HabBadge>
</template>
